"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomResponseOptionRow = exports.ClickableIcon = exports.TranslationEditorContainer = exports.NumberInput = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var SortableRow_1 = require("../../../components/common/SortableRow");
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../../contentConstants"));
var TranslationHelper_1 = require("../../../utilities/TranslationHelper");
var common_1 = require("../../common");
var TranslationEditor_1 = require("../../translations/TranslationEditor");
var responseOptionColumns = [
    { columnKey: 'cultureName', label: 'Language', editable: false },
    {
        columnKey: 'text',
        label: 'Translation',
        editable: true,
        placeholder: 'Translation text',
        requiredMessage: contentConstants_1.default.ERROR_MISSING_TRANSLATION,
        type: 'textarea',
        minHeight: '150px',
        maxWidth: '720px',
        maxLength: 150,
    },
    { columnKey: 'modifiedOn', label: 'Updated', editable: false, dataType: 'date' },
];
exports.NumberInput = (0, styled_components_1.default)(aon_tws_common_ui_1.Input)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 80px;\n\tpadding-right: 10px;\n"], ["\n\twidth: 80px;\n\tpadding-right: 10px;\n"])));
exports.TranslationEditorContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-top: 30px;\n\tmargin-bottom: 50px;\n"], ["\n\tmargin-top: 30px;\n\tmargin-bottom: 50px;\n"])));
exports.ClickableIcon = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t {\n\t\t", ";\n\t\tpadding-left: 5px;\n\t\tfont-size: ", "em;\n\t}\n"], ["\n\t {\n\t\t", ";\n\t\tpadding-left: 5px;\n\t\tfont-size: ", "em;\n\t}\n"])), function (props) { return (props.isDisabled ? "color: #999999" : "cursor: pointer"); }, function (props) { return props.fontSizeEm || 1; });
var CustomResponseOptionRow = /** @class */ (function (_super) {
    __extends(CustomResponseOptionRow, _super);
    function CustomResponseOptionRow(props) {
        var _this = _super.call(this, props) || this;
        _this.updateValue = _this.updateValue.bind(_this);
        _this.handleUpdateTranslations = _this.handleUpdateTranslations.bind(_this);
        return _this;
    }
    CustomResponseOptionRow.prototype.updateValue = function (e) {
        var value = e.target.value;
        var parsed = parseInt(value, 10);
        if (parsed > 0) {
            this.props.UpdateCustomResponseOptionValue(parsed, this.props.responseOption.id);
        }
    };
    CustomResponseOptionRow.prototype.handleUpdateTranslations = function (newTranslations, _deletedUniqueIds, _event) {
        var _this = this;
        newTranslations.forEach(function (t) {
            var roTranslation = _this.props.responseOption.translations.find(function (rot) { return rot.cultureCode === t.cultureCode; });
            if (roTranslation && roTranslation.text !== t.text) {
                _this.props.UpdateCustomResponseOptionText(t.text, roTranslation.cultureCode, _this.props.responseOption.id);
            }
        });
    };
    CustomResponseOptionRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, defaultCultureCode = _a.defaultCultureCode, isFollowUpEnabled = _a.isFollowUpEnabled, responseOption = _a.responseOption, errorMessages = _a.errorMessages;
        var textValue = TranslationHelper_1.TranslationHelper.getTranslationByCultureCode(defaultCultureCode, responseOption.translations);
        var translations = TranslationHelper_1.TranslationHelper.getEditableTranslations(responseOption.translations, defaultCultureCode);
        var textError = errorMessages.indexOf(contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_LABEL_EMPTY) > -1 ||
            errorMessages.indexOf(contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_LABEL_LENGTH_EXCEEDED) > -1;
        var valueError = errorMessages.indexOf(contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_VALUE_DUPLICATE) > -1 ||
            errorMessages.indexOf(contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_VALUE_EMPTY) > -1;
        return (React.createElement(React.Fragment, null,
            React.createElement(SortableRow_1.SortableItem, { id: this.props.responseOption.id + '', hideLeftBorder: true, key: this.props.responseOption.id, index: this.props.index, sequence: this.props.responseOption.sequence, disabled: this.props.disabled },
                React.createElement(common_1.FormattedTd, { flexBasis: 55 },
                    React.createElement(aon_tws_common_ui_1.Input, { value: textValue, size: 'sm', maxLength: 150, placeholder: contentConstants_1.default.CUSTOM_RESPONSEOPTION_LABEL_PLACEHOLDER, onChange: function (e) {
                            return _this.props.UpdateCustomResponseOptionText(e.target.value, _this.props.defaultCultureCode, _this.props.responseOption.id);
                        }, error: textError, message: this.getTextErrorMessage() })),
                translations.length > 0 && (React.createElement(common_1.FormattedTd, { flexBasis: 20 },
                    React.createElement("span", null,
                        React.createElement(aon_tws_common_ui_1.CounterPill, { size: 'sm', expectedCount: translations.length, actualCount: translations.filter(function (t) { return t.text; }).length, checkThreshold: true }),
                        React.createElement(exports.ClickableIcon, { onClick: function () { return _this.props.ToggleExpand(_this.props.responseOption.id); }, fontSizeEm: 0.8, className: 'tws-toggle-response-option-translations' },
                            React.createElement(aon_tws_common_ui_1.Icon, { name: this.props.isExpanded ? 'angle-up' : 'angle-down' }))))),
                React.createElement(common_1.FormattedTd, { flexBasis: 15 },
                    React.createElement(exports.NumberInput, { size: 'sm', type: 'number', value: this.props.responseOption.value + '', onChange: this.updateValue, error: valueError, message: this.getValueErrorMessage() })),
                isFollowUpEnabled && (React.createElement(common_1.FormattedTd, { flexBasis: 15 },
                    React.createElement(aon_tws_common_ui_1.Checkbox, { checked: responseOption.hasFollowUp, onChange: function () { return _this.props.HandleFollowUpCheck(responseOption.id); } }))),
                React.createElement(common_1.FormattedTd, { flexBasis: 10, rightAlign: true },
                    React.createElement(exports.ClickableIcon, { isDisabled: this.props.deleteDisabled, fontSizeEm: 1.5, className: 'tws-delete-response-option-button', onClick: function () { return _this.props.deleteDisabled || _this.props.DeleteResponseOption(_this.props.responseOption.id); } },
                        React.createElement(aon_tws_common_ui_1.Icon, { name: 'delete' })))),
            this.props.isExpanded && (React.createElement(exports.TranslationEditorContainer, null,
                React.createElement(TranslationEditor_1.TranslationEditor, { columns: responseOptionColumns, enableHtmlEditor: false, unStyledContainer: true, hasDefaultTranslation: textValue !== undefined && textValue !== '', property: 'CustomResponseOptionEditModel', propertyDisplayName: contentConstants_1.default.TRANSLATIONS_RESPONSEOPTION, onChange: this.handleUpdateTranslations, translations: translations, editMode: true, requireFields: ['text'], existingEditable: true })))));
    };
    CustomResponseOptionRow.prototype.getTextErrorMessage = function () {
        var errorMessages = this.props.errorMessages;
        if (errorMessages.indexOf(contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_LABEL_EMPTY) > -1) {
            return contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_LABEL_EMPTY;
        }
        else if (errorMessages.indexOf(contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_LABEL_LENGTH_EXCEEDED) > -1) {
            return contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_LABEL_LENGTH_EXCEEDED;
        }
        return '';
    };
    CustomResponseOptionRow.prototype.getValueErrorMessage = function () {
        var errorMessages = this.props.errorMessages;
        if (errorMessages.indexOf(contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_VALUE_DUPLICATE) > -1) {
            return contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_VALUE_DUPLICATE;
        }
        else if (errorMessages.indexOf(contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_VALUE_EMPTY) > -1) {
            return contentConstants_1.default.CUSTOM_RESPONSEOPTION_ERROR_VALUE_EMPTY;
        }
        return '';
    };
    return CustomResponseOptionRow;
}(React.PureComponent));
exports.CustomResponseOptionRow = CustomResponseOptionRow;
var templateObject_1, templateObject_2, templateObject_3;
